export type MapProviderName = "neshan";

export interface MapLocation {
  lat: number;
  lng: number;
  address: string;
  province?: string;
  city?: string;
  district?: string;
  formattedAddress?: string;
  provider: MapProviderName;
}

export interface MapSearchResult {
  id: string;
  title: string;
  address: string;
  lat: number;
  lng: number;
  province?: string;
  city?: string;
  district?: string;
}

export type MapErrorCode =
  | "NETWORK_ERROR"
  | "TIMEOUT"
  | "QUOTA_EXCEEDED"
  | "RATE_LIMIT"
  | "INVALID_API_KEY"
  | "NO_RESULTS"
  | "INVALID_COORDINATES"
  | "UNKNOWN";

export class MapServiceError extends Error {
  code: MapErrorCode;

  constructor(code: MapErrorCode, message: string) {
    super(message);
    this.name = "MapServiceError";
    this.code = code;
  }
}

export interface MapTileConfig {
  provider: MapProviderName;
  mapType: string;
  apiKey: string;
  customTileUrl?: string;
}

export interface MapSearchOptions {
  lat?: number;
  lng?: number;
  limit?: number;
  signal?: AbortSignal;
}

export interface ReverseGeocodeOptions {
  signal?: AbortSignal;
}
